// One field look for the public forms (the quote wizards, the partner feedback survey).
export const fieldBaseClass =
  "w-full rounded border border-border bg-white px-3.5 py-3 text-[15px] text-ink placeholder:text-ink-subtle focus:border-theme-accent focus:outline-none focus:ring-2 focus:ring-theme-accent/20";

export const labelClass = "mb-1.5 block text-[13px] font-medium text-ink";
